module.exports = __webpack_public_path__ + "05_glasses_red.50e3ab15.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/05_glasses_red.png
// module id = Wmeg
// module chunks = 0